module.exports = __webpack_public_path__ + "img/deployment.f017460b.png";